import React, { Component } from 'react';
import { Row, Card, CardTitle, Form, Label, Input, Button } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { loginUser } from '../../redux/actions';
import { Colxx } from '../../components/common/CustomBootstrap';
import IntlMessages from '../../helpers/IntlMessages';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: 'demo@gogo.com',
      password: 'gogo123',
      isPasswordVisible: false,

    };
  }

  onUserLogin() {
    if (this.state.email !== '' && this.state.password !== '') {
      this.props.loginUser(this.state, this.props.history);
    }
  }
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      isPasswordVisible: !prevState.isPasswordVisible,
    }));
  };

  render() {
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">
                AI-POWERED DIGITAL ASSISTANT FOR HOSPITALITY
              </p>
              <p className="white mb-0">
                Please use your credentials to login.
                <br />
                If you are not a member, please{' '}
                <NavLink to={`/register`} className="white">
                  register
                </NavLink>
                .
              </p>
            </div>
            <div className="form-side">
              <NavLink to={`/`}>
                {/* <span className="logo-single" /> */}
                <span className="logo-single">
                  {' '}
                  <img
                    src="/assets/img/new-bob.png"
                    width="50"
                    height="50"
                    alt="bob"
                  />{' '}
                  <b>Myma.ai</b>{' '}
                </span>
              </NavLink>
              <CardTitle className="mb-4">
                <IntlMessages id="user.login-title" />
              </CardTitle>
              <Form>
                <Label className="form-group has-float-label mb-4">
                  <Input type="email" className='input_sty' defaultValue={this.state.email} />
                  <IntlMessages id="user.email" />
                </Label>
                <Label className="form-group has-float-label mb-4">
                  <Input className='input_sty'
                    type={this.state.isPasswordVisible ? 'text' : 'password'}
                    value={this.state.password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                  />
                  <IntlMessages
                    id="user.password"
                    defaultValue={this.state.password}
                  />


                  <FontAwesomeIcon
                    icon={this.state.isPasswordVisible ? faEyeSlash : faEye}
                    onClick={this.togglePasswordVisibility}
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      right: '10px',
                      top: '10px',
                    }}
                  />
                </Label>
                <div className="d-flex justify-content-between align-items-center">
                  <NavLink to={`/forgot-password`}>
                    <IntlMessages id="user.forgot-password-question" />
                  </NavLink>
                  <Button
                    color="primary"
                    className="btn-shadow"
                    size="xs"
                    onClick={() => this.onUserLogin()}
                  >
                    <IntlMessages id="user.login-button" />
                  </Button>
                </div>
              </Form>
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    loginUser,
  }
)(Login);
